import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import "./Tags.scss";
import ReactivityTagIa from "../ReactivityTagIa/ReactivityTagIa";
import {
    fetchCategoriesRootNotIa,
    resetCategoriesRoot
} from "../../../../../../creators/categories.rootChildrens";

import ReactivityTags from "../ReactivityTags/ReactivityTags";
import {Button} from "../../../../../components/Button";



class Tags extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        window.scrollTo(0, 0);
        this.props.fetchCategoriesRootNotIa()

    }


    render() {
        let isCategories = this.props.categoriesSelectedTotal > 0;
        return (
            <div id="tag-moderations-qualification-tags">
                <ReactivityTagIa categorySlug={"temperature"} categoryTitle={"Température"} isCheck={this.props.temperatureId ? true : false} catIdSelected={this.props.temperatureId}  updateCategory={this.props.updateTemperature} />
                <ReactivityTagIa categorySlug={"gender"} categoryTitle={"Genre"} isCheck={this.props.genderId ? true : false} catIdSelected={this.props.genderId}  updateCategory={this.props.updateGender} />
                <div className={"tag-moderations-qualification-medias-tags-ia"}><p className={"inaccuracy mt-16"}>Autres tags </p></div>
                {this.props.categoriesRootInitialized && this.props.categoriesRoot.map((category, index) =>(
                    <ReactivityTags
                        key={index}
                        title={category.title}
                        id={category._id}
                        isCheck={isCategories}
                        childrens={category.childrens}
                        suggestionCategories={this.props.suggestionCategories}
                        categoriesSelected={this.props.categoriesSelected}
                        suggestionCategoriesTotal={this.props.suggestionCategories.length}
                        categoriesSelectedTotal={this.props.categoriesSelected.length}
                        updateCategoriesSelected={this.props.updateCategoriesSelected}
                    />
                ))}
                {this.props.temperatureId && this.props.genderId ? (
                    <Button
                        className={"mt-16 save-btn btn-next"}
                        btnStyle={"primary"}
                        content={"Enregistrer et continuer"}
                        onClick={()=>this.props.onSubmitCurrentMedia()}
                    />
                ) : null}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        categoriesRoot : state.categoriesRoot.data,
        categoriesRootInitialized : state.categoriesRoot.initialized,
        categoriesRootLoading : state.categoriesRoot.loading,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategoriesRootNotIa,
    resetCategoriesRoot
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Tags);